import React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

import Button from 'v3/components/Button';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function DialogContracts({ open, handleConfirm, handleClose }) {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
    >
      <DialogTitle>Documentos da viagem</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Essa viagem possui documentos importados do Benner.
          Caso opte por alterar o número da viagem, os contratos de frete, CTEs e MDFEs serão excluídos.
          <br /> <b>Deseja continuar?</b>
        </DialogContentText>
      </DialogContent>

      <Grid container justifyContent="center" spacing={2} sx={{ mb: 2 }}>
        <Grid item>
          <Button variant="danger" onClick={handleClose}>
            Não
          </Button>
        </Grid>
        <Grid item>
          <Button variant="success" onClick={handleConfirm}>
            Sim
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}
